import React, { useState } from "react";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import IconButton from "@mui/material/IconButton";
import DialogImportSpreadsheet from "../dialogs/DialogImportSpreadsheet";
import { useSnackbar } from "notistack";
import { gapi } from "gapi-script";
import Snackbar from "@mui/material/Snackbar";
import Alert from '@mui/material/Alert';
import Tooltip from "@mui/material/Tooltip";
import loadGoogleClient from "./LoadGoogleClient";


import { useProjectStore } from "../model/ProjectStore";

const readImportSheet = (project, link, enqueueSnackbar) => {
  let date = new Date();
  const splitLink = link.split("/");
  getValues(project, splitLink[5], null, importResultData, enqueueSnackbar);
};

const getValues = (project, spreadsheetId, range, callback, enqueueSnackbar) => {
  try {
    gapi.client.sheets.spreadsheets.values.get({
      spreadsheetId: spreadsheetId,
      range: "Sheet1",
    }).then((response) => {
      if (callback) callback(project, response.result);
    });
  } catch (err) {
    enqueueSnackbar(err.message, { variant: "error" });
    return;
  }
}

const importResultData = (project, result) => {
  const sheet = result.values;
  const rootTask = project.rootTaskPackage;
  let lastTask = null;
  sheet.forEach(row => {
    const code = row[0];
    if (code) {
      const task = rootTask.getTaskByCode(code);
      if (task) {
        const period = parseInt(row[2]);
        const progress = row[3];
        const cost = row[4];
        const actualProgress = task.getActualProgressForPeriod(period);
        const plannedProgress = task.getPlannedProgressForPeriod(period);
        actualProgress.progress = progress;
        actualProgress.actualCost = cost;
        lastTask = task;
      }
    }
  });

  if (lastTask) {
    lastTask.updateParentTaskPackageActuals(); 
  }
}


function ImportFromGoogleSheets() {
  const project = useProjectStore();
  const [createSheetStarted, setCreateSheetStarted] = useState(false);
  const [createSheetCompleted, setCreateSheetCompleted] = useState(false);

  const [exportEvaOpen, setExportEvaOpen] = useState(false);
  const { enqueueSnackbar } = useSnackbar();


  const handleCreate = () => {
    setExportEvaOpen(true);
  };

  const handleExportEVAClose = () => {
    setExportEvaOpen(false);
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setCreateSheetStarted(false);
    setCreateSheetCompleted(false);
  };

  const importSpreadsheet = (link) => {
    if (link == null) {
      return;
    }
    readImportSheet(project,
      link,
      enqueueSnackbar);
    enqueueSnackbar("Import Finished!", {
            variant: "success",
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "center",
            },
          })
    setExportEvaOpen(false);
  };

  return (
    <div className="AddGoogleSheetButton">
      <Tooltip title="Import Spreadsheet" aria-label="Import Data From GoogleSheets">
        <IconButton onClick={() => handleCreate()} color="inherit">
          <NoteAddIcon />
        </IconButton>
      </Tooltip>
      <DialogImportSpreadsheet
        open={exportEvaOpen}
        onCancel={handleExportEVAClose}
        onSave={(link) => loadGoogleClient(() => importSpreadsheet(link))}
      />
      <Snackbar
        title="Read Spreadsheet Start"
        open={createSheetStarted}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity="info"
          sx={{ width: "100%" }}
        >
          Reading Spreadsheet for Import...
        </Alert>
      </Snackbar>
      <Snackbar
        title="Read Spreadsheet End"
        open={createSheetCompleted}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity="success"
          sx={{ width: "100%" }}
        >
          Successfully Imported the Spreadsheet
        </Alert>
      </Snackbar>
    </div>
  );
}

export default ImportFromGoogleSheets;
